import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-bdc-wizard-complete',
  templateUrl: './connect-bdc-wizard-complete.component.html',
  styleUrls: ['./connect-bdc-wizard-complete.component.scss'],
})
export class ConnectBDCWizardCompleteComponent implements OnInit {
  @Input() propertyId: string
  @Output() reset = new EventEmitter()
  @Output() channel = new EventEmitter()
  @Output() done = new EventEmitter()
  @Output() prev = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
